import React from "react";
import { Box, Checkbox, Chip } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import TextField from "components/TextField";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

interface ParkSelectProps {
  selectedParks?: { title: string; value: number }[];
  setSelectedParks?: (clients: { title: string; value: number }[]) => void;
  parks: any;
  formValues?: any;
  setFormValues?: React.Dispatch<React.SetStateAction<any>>;
  minWidth?: number;
  maxWidth?: number;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
}

const ParkSelect: React.FC<ParkSelectProps> = ({
  selectedParks,
  setSelectedParks,
  formValues,
  setFormValues,
  parks,
  minWidth = 480,
  maxWidth = 480,
  label = "Park",
  placeholder = "Search by park name",
  disabled,
}) => {
  const handleSelectPark = (option: { title: string; value: number }) => {
    let selectedParksData = [...selectedParks];

    if (!!selectedParks.find((sc) => sc.value === option.value)) {
      selectedParksData = selectedParksData.filter(
        (sc) => sc.value !== option.value,
      );
    } else {
      selectedParksData = [...selectedParksData, option];
    }

    setSelectedParks(selectedParksData);
    if (setFormValues) {
      setFormValues({ ...formValues, selectedParks: selectedParksData });
    }
  };

  const handleRemoveSelectedPark = (option: {
    title: string;
    value: number;
  }) => {
    let selectedParksData = [...selectedParks];
    selectedParksData = selectedParksData.filter(
      (sc) => sc.title !== option.title,
    );
    setSelectedParks(selectedParksData);
    if (setFormValues) {
      setFormValues({ ...formValues, selectedParks: selectedParksData });
    }
  };

  return (
    <Box>
      <Autocomplete
        multiple
        id="selectedParks"
        value={selectedParks}
        limitTags={2}
        disabled={disabled}
        disableCloseOnSelect
        renderTags={(value, getTagProps) =>
          value?.map((option, index) => {
            const { key } = getTagProps({ index });
            return (
              <Chip
                label={option.title}
                key={key}
                onDelete={() => handleRemoveSelectedPark(option)}
                size="small"
                sx={{ mr: "4px", mb: "4px" }}
              />
            );
          })
        }
        options={parks}
        getOptionLabel={(option) => option.title}
        defaultValue={[]}
        size="small"
        renderInput={(params) => (
          <TextField
            id="client"
            params={params}
            minWidth={minWidth}
            maxWidth={maxWidth}
            label={label}
            placeholder={placeholder}
          />
        )}
        renderOption={(props, option) => {
          const isSelected = !!selectedParks.find(
            (sc) => sc.value === option.value,
          );

          return (
            <li
              {...props}
              style={{ padding: "0rem" }}
              onClick={() => handleSelectPark(option)}
            >
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 4 }}
                checked={isSelected}
              />
              {option.title}
            </li>
          );
        }}
      />
    </Box>
  );
};

export default ParkSelect;
